/**
 * Supported colors.
 */
export const COLORS = {
    GREEN: 'green',
    BLUE: 'blue',
    ORANGE: 'orange',
    RED: 'red'
} as const;

/**
 * Supported themes.
 */
export const THEMES = {
    COLORFUL: 'colorful',
    MATERIAL: 'material'
} as const;
